import { render, staticRenderFns } from "./PrecosNota.vue?vue&type=template&id=96029254&scoped=true"
import script from "./PrecosNota.vue?vue&type=script&lang=js"
export * from "./PrecosNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96029254",
  null
  
)

export default component.exports